module.exports = __webpack_public_path__ + "static/media/SC.cce32f91.png";